import {cookieUtil} from './cookie-util.js';

export var userProfileManager = (function() {
    // *******************
    // Moved the global variables fro outside to here....
    // and return it outside
    var LEGACY_USER_ROLE = {
        PRIMARY: 'PRIMARY',
        ASSOCIATE: 'ASSOCIATE'
    };
    var USER_ROLE = {
        PRIMARY: 'Primary',
        ASSOCIATE: 'Associate',
        FAMILY_MEMBER: 'FamilyMember'
    };
    var LEGACY_USER_TYPE = {
        RETAIL_CUSTOMER: 'CUST',
        PREFERRED_CUSTOMER: 'PREF',
        PREFERRED_CUSTOMER_ALT: 'PREFERRED',
        PRIMARY_DISTRIBUTOR: 'DIST',
        ASSOCIATE: 'ASSOC',
        FAMILY_MEMBER: 'FAMILY'
    };
    var USER_TYPE = {
        RETAIL_CUSTOMER: 'Retail_Customer',
        PREFERRED_CUSTOMER: 'Preferred_Customer',
        PRIMARY_DISTRIBUTOR: 'Primary_Distributor',
        AGENT: 'AGENT',
        RETAILER: 'RETAILER',
        ASSOCIATE: 'Associate',
        FAMILY_MEMBER: 'FamilyMember'
    };
    var CUST_CLASS = {
        RETAIL: 'Retail',
        PMPC: 'PMPC',
        PERMANENT: 'Permanent'
    };
    var INVITE_STATUS = {
        PENDING: 'ACCOUNT PENDING',
        COMPLETE: 'Complete'
    };
    var INVITATION_TYPE = {
        DISTRIBUTOR: 'DISTRIBUTOR',
        INDIVIDUAL: 'INDIVIDUAL',
        RETAILER: 'RETAILER',
        PREFERRED_CUSTOMER: 'PREFERRED_CUST',
        RETAIL_CUSTOMER: 'RETAIL_CUST',
        ASSOCIATE: 'ASSOCIATE',
        COMPANY: 'COMPANY'
    };

    var LOGGEDIN_KEY = 'loggedIn';
    var JWT_KEY = 'USER_PROFILE_JWT';
    var USER_PROFILE_MIN__KEY = 'USER_PROFILE_MIN_INFO';
    var USER_PROFILE_MASTER__KEY = 'USER_PROFILE_MASTER_INFO';
    var RETURN_URL_KEY = 'PAGE_RETURN_URL';
    var SPONSOR_RETURN_URL_KEY = 'SPONSOR_RETURN_URL_KEY';
    var INVITE_URL_KEY = 'INVITE_RETURN_URL';
    var SIGNUP_USER_TYPE = 'SGUP_ROLE_USER';
    var CUST_TO_IND_DIST_RET_PAGE = 'CUST_TO_IND_DIST_RET_PAGE';
    var HOST_INFO = 'HOST_INFO';
    var GUID = 'GUID';
    var UUID = 'UUID';
    var LANGUAGE='language';
    var MARKET='market';
    var UNAME_KEY = 'uname';

    var getUserProfileMasterInfo = function() {
        var data = cookieUtil.getCookie(USER_PROFILE_MASTER__KEY);
        if (null != data && undefined != data && 0 < data.length) {
            return JSON.parse(cookieUtil.getCookie(USER_PROFILE_MASTER__KEY));
        } else {
            return null;
        }
    };

    return {
        USER_ROLE: USER_ROLE,
        USER_TYPE: USER_TYPE,
        CUST_CLASS: CUST_CLASS,
        INVITE_STATUS: INVITE_STATUS,
        INVITATION_TYPE: INVITATION_TYPE,
        LEGACY_USER_TYPE: LEGACY_USER_TYPE,
        // *******************
        // Changed from this.determineUserType
        determinUserType: function(userData) {
            var userType = null;
            if (userData['customerClass']) {
                if (userData['customerClass'] === CUST_CLASS.RETAIL) {
                    userType = USER_TYPE.RETAIL_CUSTOMER;
                } else if (userData['customerClass'] === CUST_CLASS.PMPC) {
                    userType = USER_TYPE.PREFERRED_CUSTOMER;
                } else if (userData['customerClass'] === CUST_CLASS.PERMANENT) {
                    if (userData['userRole'] === USER_ROLE.PRIMARY) {
                        userType = USER_TYPE.PRIMARY_DISTRIBUTOR;
                    } else if (userData['userRole'] === USER_ROLE.ASSOCIATE) {
                        userType = USER_TYPE.ASSOCIATE;
                    } else if (userData['userRole'] === USER_ROLE.FAMILY_MEMBER) {
                        userType = USER_TYPE.FAMILY_MEMBER;
                    }
                }
            }
            return userType;
        },

        // *************************************
        // ************ New Services ***********
        setUserProfileNew: function(loginData, accountData) {
            var jwt = loginData.eid;
            var userProfileMinInfo = this.transformPersonInfo(loginData);

            // ***** set cookies *********
            cookieUtil.setCookie(JWT_KEY, JSON.stringify(jwt));
            localStorage.setItem(USER_PROFILE_MIN__KEY, JSON.stringify(accountData));
            cookieUtil.setCookie(USER_PROFILE_MASTER__KEY, JSON.stringify(userProfileMinInfo));
        },

        transformPersonInfo: function(data) { // This data could be gotten from the authorize call.
            var userData = {
                'accountId': data.person.sapID,
                'accountType': 'Individual',
                'emailId': data.person.email,
                'emailVerified': false,
                'gigyaId': data.person.gigyaUID,
                'userId': data.person.personID.toLowerCase(),
                'userRole': 'Primary',
                'userType': 'Primary_Distributor',
                'username': ''
            };

            //  data.account.header.accountType;
            // emailId data.contactInfo.email

            // userRole
            if (data.person.type == LEGACY_USER_ROLE.ASSOCIATE) {
                userData.userRole = USER_ROLE.ASSOCIATE;
            } else if (data.person.type == LEGACY_USER_ROLE.PRIMARY) {
                userData.userRole = USER_ROLE.PRIMARY;
            }

            // userType
            if (data.account.customerType == LEGACY_USER_TYPE.PRIMARY_DISTRIBUTOR) {
                if (data.person.type == LEGACY_USER_ROLE.ASSOCIATE) {
                    userData.userType = USER_TYPE.ASSOCIATE;
                } else {
                    userData.userType = USER_TYPE.PRIMARY_DISTRIBUTOR;
                }
            } else if (data.account.customerType == LEGACY_USER_TYPE.PREFERRED_CUSTOMER
                || data.account.customerType == LEGACY_USER_TYPE.PREFERRED_CUSTOMER_ALT) {
                userData.userType = USER_TYPE.PREFERRED_CUSTOMER;
            } else if (data.account.customerType == LEGACY_USER_TYPE.RETAIL_CUSTOMER) {
                userData.userType = USER_TYPE.RETAIL_CUSTOMER;
            }
            var uname = cookieUtil.getCookie(UNAME_KEY);
            if (null != uname && undefined != uname && 0 < uname.length) {
                userData.username = uname;
            }

            return userData;
        },

        // *************************************

        setUserProfile: function(loginData, accountData) {
            var jwt = loginData.eid;
            var userProfileMasterInfo = this.transformPersonInfo(loginData);
            var userProfileMinInfo=this.transformMinInfo(accountData);

            // ***** set cookies *********
            cookieUtil.setCookie(JWT_KEY, JSON.stringify(jwt));
            localStorage.setItem(USER_PROFILE_MIN__KEY, JSON.stringify(userProfileMinInfo));
            cookieUtil.setCookie(USER_PROFILE_MASTER__KEY, JSON.stringify(userProfileMasterInfo));
            cookieUtil.setCookie(LOGGEDIN_KEY, true);
            this.storeUserInfo(loginData);
        },

        transformMinInfo: function(data) {
            var minData={};

            if (data.personID) { // Todo profileThumbnailUrl - This is missing from the authorize call for the person.
                minData.profileCommPreferences ={
                    'gender': '',
                    'languagePreferences': data.preferredLanguage,
                    'marketingEmail': true
                };
                minData.profileContactInfo = {
                    'email': data.email
                };
                minData.profileHeader ={
                    'accountId': data.sapID,
                    'firstName': data.firstName,
                    'lastName': data.lastName,
                    'profileThumbnailUrl': data.profileThumbnailUrl,
                    'preferredName': data.preferredName,
                    'userId': data.personID
                };
                minData.profilePersonalInfo = {
                    'gender': '',
                    'personalId': data.personID
                };
                minData.profileSponsorDetails = {
                    'id': data.sponsorID,
                    'country': '',
                    'names': {
                        'default': ''
                    }};


                minData.profilePrivacyOptionInfo = {
                    'acceptMarketingEmail': true,
                    'acceptMarketingSMS': false,
                    'contactPreference': 'EMAIL',
                    'showContactInfo': false,
                    'showContactInfoToFamilyAndFriends': false,
                    'showContactInfoToFirstUpLine': false,
                    'visibleInScannerLocator': false,
                    'visibleInSponsorSearch': false
                };
            } else {
                try {
                    minData.profileCommPreferences = {
                        gender: data.person.gender, // Todo gender - This is missing from the authorize call for the person.
                        languagePreferences: data.person.preferredLanguage,
                        marketingEmail: data.person.preferences.acceptMarketingEmail, // Todo preferences.acceptMarketingEmail - This is missing from the authorize call for the person.
                    };
                    minData.profileContactInfo = {
                        email: data.person.email,
                    };
                    minData.profileHeader = {
                        accountId: data.person.accountID,
                        firstName: data.person.names.local.given, // Todo names.local.given - This is missing from the authorize call for the person.
                        lastName: data.person.names.local.family, // Todo names.local.family - This is missing from the authorize call for the person.
                        profileThumbnailUrl: data.person.profileThumbnailUrl,
                        preferredName: data.person.preferredName,
                        userId: data.person.id,
                    };
                    minData.profilePersonalInfo = {
                        gender: data.person.gender,
                        personalId: data.person.id,
                    };
                    minData.profileSponsorDetails = data.sponsor; // Todo sponsor - This is missing from the authorize call for the person.
                    minData.profilePrivacyOptionInfo = data.person.preferences; // Todo preferences - This is missing from the authorize call for the person.
                } catch (exception) {
                }
            }
            return minData;
        },

        getAccountType: function() {
            var custType = '';
            try {
                custType = getUserProfileMasterInfo().userType;
            } catch (e) {
                custType = '';
            }

            if (custType == 'Primary_Distributor' || custType == 'Associate') {
                return '10';
            } else if (custType == 'Retail_Customer') {
                return '20';
            } else if (custType == 'Preferred_Customer') {
                return '30';
            } else {
                return '0';
            }
        },

        setAccountType: function(custType) {
            if (custType == 'DIST' || custType == 'DISTRIBUTOR') {
                return '10';
            } else if (custType == 'CUST' || custType == 'CUSTOMER') {
                return '20';
            } else if (custType == 'PREF' || custType == 'PREFERREDCUST' || custType == 'PREFERRED') {
                return '30';
            } else {
                return '0';
            }
        },

        getCustomerType: function(custType) {
            if (custType == 'DIST') {
                return 'DISTRIBUTOR';
            } else if (custType == 'CUST') {
                return 'CUSTOMER';
            } else if (custType == 'PREF' || custType == 'PREFERRED') {
                return 'PREFERREDCUST';
            } else {
                return '';
            }
        },

        storeUserInfo: function(userData) {
            var loginTime = new Date().getTime();
            var resultObject = {user: {
                'id': userData.account.id,
                'name': userData.person.localName,
                'localName': userData.person.localName,
                'email': userData.person.email,
                'accountType': this.setAccountType(userData.account.customerType),
                'countryCd': userData.country,
                'priceType': userData.account.priceType,
                'customerType': this.getCustomerType(userData.account.customerType),
                'eid': userData.eid,
                'lastName': userData.person.lastName,
                'firstName': userData.person.firstName,
                'loginTime': loginTime
            }};

            localStorage.setItem('nuskin.account.data', JSON.stringify(resultObject));
        },

        deleteUserProfile: function() {
            cookieUtil.setCookie(JWT_KEY, '', -1);
            localStorage.removeItem(USER_PROFILE_MIN__KEY);
            cookieUtil.setCookie(USER_PROFILE_MIN__KEY, '', -1); // this will need to be removed eventualy
            cookieUtil.setCookie(USER_PROFILE_MASTER__KEY, '', -1);
            cookieUtil.setCookie(RETURN_URL_KEY, '', -1);
            cookieUtil.setCookie(SIGNUP_USER_TYPE, '', -1);
            cookieUtil.setCookie(CUST_TO_IND_DIST_RET_PAGE, '', -1);
            cookieUtil.setCookie(GUID, '', -1);
            cookieUtil.setCookie(UUID, '', -1);
            cookieUtil.setCookie(HOST_INFO, '', -1);
            cookieUtil.setCookie(LOGGEDIN_KEY, '', -1);
        },

        logoutButKeepHostData: function() {
            // keeping SIGNUP_USER_TYPE, GUID, UUID, HOST_INFO
            cookieUtil.setCookie(JWT_KEY, '', -1);
            localStorage.removeItem(USER_PROFILE_MIN__KEY);
            cookieUtil.setCookie(USER_PROFILE_MIN__KEY, '', -1); // this will need to be removed eventualy
            cookieUtil.setCookie(USER_PROFILE_MASTER__KEY, '', -1);
            cookieUtil.setCookie(RETURN_URL_KEY, '', -1);
            cookieUtil.setCookie(CUST_TO_IND_DIST_RET_PAGE, '', -1);
            cookieUtil.setCookie(LOGGEDIN_KEY, '', -1);
            cookieUtil.setCookie('cart_guid', '', -1);
            try {
                gigya.accounts.logout({
                    forceProvidersLogout: true
                });
            } catch(e) {}
        },

        getJWT: function() {
            var jwt = cookieUtil.getCookie(JWT_KEY);
            if (null != jwt && undefined != jwt && 0 < jwt.length) {
                if (cookieUtil.getCookie(LOGGEDIN_KEY) === 'true') {
                    return JSON.parse(cookieUtil.getCookie(JWT_KEY));
                } else {
                    this.deleteUserProfile();
                }
            }
            return null;
        },
        getUserProfileDetailInfo: function() {
            var data = localStorage.getItem(USER_PROFILE_MIN__KEY);
            if (null != data && undefined != data && 0 < data.length) {
                return JSON.parse(localStorage.getItem(USER_PROFILE_MIN__KEY));
            } else {
                return null;
            }
        },
        setUserProfileDetailInfo: function(userProfileMinInfo) {
            cookieUtil.setCookie(USER_PROFILE_MIN__KEY, JSON.stringify(userProfileMinInfo));
        },
        getUserProfileMasterInfo: getUserProfileMasterInfo,
        setUserProfileMasterInfo: function(userProfileMasterInfo) {
            cookieUtil.setCookie(USER_PROFILE_MASTER__KEY, JSON.stringify(userProfileMasterInfo));
        },
        getHostInfo: function() {
            var data = cookieUtil.getCookie(HOST_INFO);
            if (null != data && undefined != data && 0 < data.length) {
                return JSON.parse(cookieUtil.getCookie(HOST_INFO));
            } else {
                return null;
            }
        },
        isUserLoggedIn: function() {
            var jwt = this.getJWT();
            if (null != jwt && undefined != jwt && 0 < jwt.length && this.isSignInMandatoryCookiesPresent()) {
                return true;
            }
            return false;
        },
        setPageReturnURL: function(url) {
            cookieUtil.setCookie(RETURN_URL_KEY, JSON.stringify(url));
        },
        getPageReturnURL: function() {
            var data = cookieUtil.getCookie(RETURN_URL_KEY);
            if (null != data && undefined != data && 0 < data.length) {
                return JSON.parse(cookieUtil.getCookie(RETURN_URL_KEY));
            } else {
                return null;
            }
        },
        setInviteUrl: function(url) {
            cookieUtil.setCookie(INVITE_URL_KEY, JSON.stringify(url));
        },
        getInviteUrl: function() {
            var data = cookieUtil.getCookie(INVITE_URL_KEY);
            if (null != data && undefined != data && 0 < data.length) {
                return JSON.parse(cookieUtil.getCookie(INVITE_URL_KEY));
            } else {
                return null;
            }
        },
        setCustomerConvertionReturnURL: function(url) {
            cookieUtil.setCookie(CUST_TO_IND_DIST_RET_PAGE, JSON.stringify(url));
        },
        getCustomerConvertionReturnURL: function() {
            var data = cookieUtil.getCookie(CUST_TO_IND_DIST_RET_PAGE);
            if (null != data && undefined != data && 0 < data.length) {
                return JSON.parse(cookieUtil.getCookie(CUST_TO_IND_DIST_RET_PAGE));
            } else {
                return null;
            }
        },
        setSignUpUserType: function(role) {
            cookieUtil.setCookie(SIGNUP_USER_TYPE, role);
        },
        getSignUpUserType: function() {
            var data = cookieUtil.getCookie(SIGNUP_USER_TYPE);
            if (null != data && undefined != data && 0 < data.length) {
                return cookieUtil.getCookie(SIGNUP_USER_TYPE);
            } else {
                return null;
            }
        },
        setGuid: function(guid) {
            cookieUtil.setCookie(GUID, guid);
        },
        getGuid: function() {
            var data = cookieUtil.getCookie(GUID);
            if (null != data && undefined != data && 0 < data.length) {
                return cookieUtil.getCookie(GUID);
            } else {
                return null;
            }
        },
        setUUID: function(uuid) {
            cookieUtil.setCookie(UUID, uuid);
        },
        getUUID: function() {
            var data = cookieUtil.getCookie(UUID);
            if (null != data && undefined != data && 0 < data.length) {
                return cookieUtil.getCookie(UUID);
            } else {
                return null;
            }
        },
        setSponsorPageReturnURL: function(url) {
            cookieUtil.setCookie(SPONSOR_RETURN_URL_KEY, JSON.stringify(url));
        },
        getSponsorPageReturnURL: function() {
            var data = cookieUtil.getCookie(SPONSOR_RETURN_URL_KEY);
            if (null != data && undefined != data && 0 < data.length) {
                return JSON.parse(cookieUtil.getCookie(SPONSOR_RETURN_URL_KEY));
            } else {
                return null;
            }
        },
        setPageLocaleVal: function(data) {
            cookieUtil.setCookie(LANGUAGE, data.language);
            cookieUtil.setCookie(MARKET, data.market);
        },
        getPageLocaleVal: function(data) {
            var languageVal = nuskin.util.languageCode;
            var marketVal = nuskin.configuration.markets;
            if (languageVal && marketVal) {
                return {
                    language: languageVal,
                    market: marketVal
                };
            } else {
                return null;
            }
        },

        getJWTKey: function() {
            return JWT_KEY;
        },

        // ###### CHANGED for refactoring
        // deleteUserProfileCookiesAndSignOut: function(actionDesc,index, isOpenInNewWindow){
        //    var URL = angular.element($('#'+actionDesc+index)).val();
        deleteUserProfileCookiesAndSignOut: function(URL, isOpenInNewWindow) {
            userProfileManager.deleteUserProfile();
            cookieUtil.setCookie('cart_guid', '', -1);
            gigya.accounts.logout({
                forceProvidersLogout: true
            });

            if (undefined != URL && null != URL && '' != URL) {
                if (undefined != isOpenInNewWindow && isOpenInNewWindow) {
                    window.open(URL);
                } else {
                    window.location = window.location.protocol+'//'+window.location.host+ URL + '.html';
                }
            }
        },
        isMandatoryInfoAvailable: function(hybrisResponse) {
            var isMandatoryInfoPresent = false;
            var userData = hybrisResponse.userData;

            if (this.isAccountInfoMissing(userData) && this.isUserInfoMissing(userData)) {
                isMandatoryInfoPresent = true;
            }

            return isMandatoryInfoPresent;
        },

        isAccountInfoMissing: function(userData) {
            if (null != userData.accountId && undefined !=userData.accountId && null != userData.emailId
                && undefined !=userData.emailId && userData.alphaAccount ) {
                return true;
            }

            return false;
        },

        isUserInfoMissing: function(userData) {
            if (null != userData.userId && undefined !=userData.userId && null != userData.userRole
                && undefined !=userData.userRole && null != userData['customerClass']
                && undefined !=userData['customerClass'] ) {
                return true;
            }

            return false;
        },

        getProfileImageReference: function() {
            var profileImageRef = '';
            profileImageRef = angular.element($('#profileImageReferencePath')).val();
            return profileImageRef;
        },

        isSignInMandatoryCookiesPresent: function() {
            var userProfileMaster = getUserProfileMasterInfo();
            var userProfileMiniInfo = this.getUserProfileDetailInfo();

            if ('' != userProfileMaster && undefined !=userProfileMaster && null!=userProfileMaster
                && '' != userProfileMiniInfo && undefined !=userProfileMiniInfo && null!=userProfileMiniInfo) {
                return true;
            } else {
                return false;
            }
        },

        redirectUserToSprinkrAssetSharePage: function(socialAssetShareURL) {
            var sprinklrURL = sprinklrBaseURL;
            window.location.href = sprinklrURL+socialAssetShareURL;
        },

        returnUserMarket: function() {
            var userMarket;
            try {
                var userProfileInfo = getUserProfileMasterInfo();
                if (userProfileInfo === null) {
                    console.warn('user profile info is null, returning market null');
                    return null;
                }
                userMarket = userProfileInfo.accountId.substr(0, 2);
            } catch (e) {
                console.error('Unable to get market');
                if (nuskin.configuration.markets) {
                    userMarket = nuskin.configuration.markets;
                }
            }
            if (userMarket == 'UK' || userMarket == 'uk') {
                userMarket = 'GB';
            }
            if (userMarket == 'AS' || userMarket == 'as') {
                userMarket = 'AU';
            }
            return userMarket;
        },

        isUserDistributor: function(userType) {
            return (userType === USER_TYPE.PRIMARY_DISTRIBUTOR) || (userType === LEGACY_USER_TYPE.PRIMARY_DISTRIBUTOR);
        },

        isUserAgentDistributor: function(userType) {
            return (userType === USER_TYPE.AGENT);
        },

        isUserRetailerDistributor: function(userType) {
            return (userType === USER_TYPE.RETAILER);
        },

        isUserPreferredCustomer: function(userType) {
            return (userType === USER_TYPE.PREFERRED_CUSTOMER) || (userType === LEGACY_USER_TYPE.PREFERRED_CUSTOMER);
        },

        isUserRetailCustomer: function(userType) {
            return (userType === USER_TYPE.RETAIL_CUSTOMER) || (userType === LEGACY_USER_TYPE.RETAIL_CUSTOMER);
        },

        isUserAssociate: function(userType) {
            return (userType.toUpperCase() === USER_TYPE.ASSOCIATE.toUpperCase())
                || (userType.toUpperCase() === LEGACY_USER_TYPE.ASSOCIATE.toUpperCase());
        },

        isUserFamilyMember: function(userType) {
            return (userType === USER_TYPE.FAMILY_MEMBER) || (userType === LEGACY_USER_TYPE.FAMILY_MEMBER);
        },

        isUserCustomer: function(userType) {
            return userProfileManager.isUserPreferredCustomer(userType)
                || userProfileManager.isUserRetailCustomer(userType);
        },

        isUserCustomerOrDistributor: function(userType) {
            return userProfileManager.isUserDistributor(userType)
                || userProfileManager.isUserPreferredCustomer(userType)
                || userProfileManager.isUserRetailCustomer(userType);
        },

        isUserAssociateOrFamilyMember: function(userType) {
            return userProfileManager.isUserAssociate(userType) || userProfileManager.isUserFamilyMember(userType);
        },

        isUserFamilyMemberOrCustomer: function(userType) {
            return userProfileManager.isUserFamilyMember(userType)
                || userProfileManager.isUserPreferredCustomer(userType)
                || userProfileManager.isUserRetailCustomer(userType);
        },

        /*
            Checks if distributor is of type: Individual, Business(not present yet), or Retailer
         */
        isInviteDistributor: function(invitationType) {
            return (invitationType === INVITATION_TYPE.DISTRIBUTOR || invitationType === USER_TYPE.PRIMARY_DISTRIBUTOR);
        },

        isInviteAnyDistributor: function(invitationType) {
            return (userProfileManager.isInviteDistributor(invitationType)
                || userProfileManager.isInviteIndividual(invitationType)
                || userProfileManager.isInviteRetailer(invitationType));
        },

        isInviteIndividual: function(invitationType) {
            return (invitationType === INVITATION_TYPE.INDIVIDUAL);
        },

        isInviteRetailer: function(invitationType) {
            return (invitationType === INVITATION_TYPE.RETAILER);
        },

        /*
            Checks if customer is preferred or retail customer type.
         */
        isInviteCustomer: function(invitationType) {
            return (userProfileManager.isInvitePreferredCustomer(invitationType)
                || userProfileManager.isInviteRetailCustomer(invitationType));
        },

        isInvitePreferredCustomer: function(invitationType) {
            return (invitationType === INVITATION_TYPE.PREFERRED_CUSTOMER
                || invitationType === USER_TYPE.PREFERRED_CUSTOMER);
        },
        isInviteRetailCustomer: function(invitationType) {
            return (invitationType === INVITATION_TYPE.RETAIL_CUSTOMER || invitationType === USER_TYPE.RETAIL_CUSTOMER);
        },

        isInviteAssociate: function(invitationType) {
            return (invitationType === INVITATION_TYPE.ASSOCIATE || invitationType === USER_TYPE.ASSOCIATE);
        },

        isInviteCustomerOrDistributor: function(invitationType) {
            return userProfileManager.isInviteDistributor(invitationType)
                || userProfileManager.isInvitePreferredCustomer(invitationType)
                || userProfileManager.isInviteRetailCustomer(invitationType);
        }
    };
})();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/user-profile-manager.js
// module id = 4
// module chunks = 0